import { render, staticRenderFns } from "./ScheduledMailList.vue?vue&type=template&id=632bb994"
import script from "./ScheduledMailList.vue?vue&type=script&lang=js"
export * from "./ScheduledMailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports